<template>
  <div class="sysdev-box">
    <div class="content">
      <img src="@/assets/business/sysdev_img.png" alt="" />
      <div class="en-title">{{ "system".toUpperCase() }}</div>
      <div class="cn-title">系统开发</div>
      <div v-html="cleanHtmlText(data.content)"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
